import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useEffect, useState } from "react";
import Indicator from "../Indicator";
import InputGlobal from "../InputGlobal";
import { validateEmail, simplyClick } from "../../helpers";
import ButtonGroup from "../ButtonGroup";
import cn from "classnames";
import EmailLoader from "../LoaderEmail/index";
import { bodyTypes, landingId } from "../../constants";
import { useWizardAnswers } from "ui-components";

import skinnyIcon from "../../images/ico_skinny.svg";
import averageIcon from "../../images/ico_average.svg";
import modelIcon from "../../images/ico_model.svg";
import plusIcon from "../../images/ico_plus-size.svg";
import BigIcon from "../../images/ico_big.svg";
import dontCareIcon from "../../images/ico_question-mark.svg";

import "./Email.scss";
import {
  ERROR_EMAIL_ALREADY_REGISTERED,
  errorEventsEmail,
  IS_VISIBLE_CUSTOM_AUTOCOMPLETE,
} from "../../constants";
import CustomEmailAutoComplete from "../CustomEmailAutoComplete";
import Tooltip from "../Tooltip";

const Email = ({ step, setStep }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorEmail, setErrorEmail] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [emailLoader, setEmailLoader] = useState({
    show: false,
    textMain: "",
    textSub: "",
  });

  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const updateAnswer = useWizardAnswers();

  const handleSelectIndicator = (id) => {
    const selected = bodyTypes[id];

    if (!selected) return;

    setSelectedIndicator(selected.label);
    updateAnswer({ body_type: [String(id)] });

    if (selected.event) {
      simplyClick(selected.event);
    }
  };

  const handlerSubmit = () => {
    if (!selectedIndicator) {
      updateAnswer({ body_type: ["0"] });
    }

    setEmailLoader({
      show: true,
      textMain: "Verifying your email...",
      textSub: "This might take a moment.",
    });

    const textTimeout = setTimeout(() => {
      setEmailLoader({
        show: true,
        textMain: "Still verifying your email...",
        textSub: "Thanks for your patience!",
      });
    }, 3000);

    validateEmail(data.email, (result) => {
      clearTimeout(textTimeout);
      setEmailLoader({ show: false, textMain: "", textSub: "" });

      const { status, error } = result;
      if (!status && error) {
        if (error === ERROR_EMAIL_ALREADY_REGISTERED) {
          setShowLogin(true);
        }
        const analyticsEvent = errorEventsEmail[error];
        if (analyticsEvent) {
          simplyClick(analyticsEvent);
        }
        setErrorEmail(error);
        return;
      }

      setStep(step + 1);
    });
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_am30_email_back");
    setStep(step - 1);
  };

  const handleAddEmail = ({ target: { value } }) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setData({ ...data, email: value });
  };

  const handleGetEmailParams = (e) => {
    e.preventDefault();
    const email = data?.email;
    simplyClick("cl_lnd_am30_againemail_login");

    if (email) {
      window.location.href = `/login/?email=${encodeURIComponent(email)}`;
    }
  };

  return (
    <>
      {emailLoader.show && (
        <EmailLoader
          textMain={emailLoader.textMain}
          textSub={emailLoader.textSub}
        />
      )}
      <div className="global__form-wrap">
        <div className="email__form">
          <h5 className="form__title">
            What body type do you find most attractive?
          </h5>
          <div className="group__top">
            <Indicator
              textLabel={bodyTypes[1].label}
              iconIndicator={skinnyIcon}
              className="component-1"
              isActive={selectedIndicator === bodyTypes[1].label}
              onClick={() => handleSelectIndicator(1)}
            />
            <Indicator
              textLabel={bodyTypes[2].label}
              iconIndicator={modelIcon}
              className="component-2"
              isActive={selectedIndicator === bodyTypes[2].label}
              onClick={() => handleSelectIndicator(2)}
            />
            <Indicator
              textLabel={bodyTypes[3].label}
              iconIndicator={averageIcon}
              className="component-3"
              isActive={selectedIndicator === bodyTypes[3].label}
              onClick={() => handleSelectIndicator(3)}
            />
          </div>
          <div className="group__bottom">
            <Indicator
              textLabel={bodyTypes[4].label}
              iconIndicator={plusIcon}
              className="component-4"
              isActive={selectedIndicator === bodyTypes[4].label}
              onClick={() => handleSelectIndicator(4)}
            />
            <Indicator
              textLabel={bodyTypes[5].label}
              iconIndicator={BigIcon}
              className="component-5"
              isActive={selectedIndicator === bodyTypes[5].label}
              onClick={() => handleSelectIndicator(5)}
            />
            <Indicator
              textLabel={bodyTypes[6].label}
              iconIndicator={dontCareIcon}
              className="component-6"
              isActive={selectedIndicator === bodyTypes[6].label}
              onClick={() => handleSelectIndicator(6)}
            />
          </div>
          <span className="line" />
          <h5 className="form__title">Enter your email to create an account</h5>
          <div className="email_input">
            <div className="has-float-label">
              <InputGlobal
                className={cn("input__global", {
                  error: errorEmail,
                  active:
                    data.email?.length > 0 &&
                    !data.email?.includes("@") &&
                    IS_VISIBLE_CUSTOM_AUTOCOMPLETE,
                })}
                onChange={handleAddEmail}
                name={"email"}
                placeholder={"Enter a valid email"}
                type={"text"}
                id={"email__30"}
                value={data.email || ""}
                autoComplete="email"
                onFocus={() => {
                  if (!data.email) {
                    setShowTooltip(true);
                  }
                  simplyClick("cl_lnd_am30_email_type_email");
                }}
                onBlur={() => setShowTooltip(false)}
              />
              <label htmlFor="email__30" className={errorEmail ? "error" : ""}>
                Enter a valid email
              </label>
              {IS_VISIBLE_CUSTOM_AUTOCOMPLETE && (
                <CustomEmailAutoComplete
                  errorEmail={errorEmail}
                  errorCb={() => setErrorEmail(null)}
                />
              )}

              {errorEmail && <p className="error-text">{errorEmail}</p>}
            </div>
            <Tooltip
              text="We'll use this email for account verification and important notifications."
              showTooltip={showTooltip}
              className="email"
            />
            {showLogin && (
              <div className="email_login-wrap">
                <a
                  onClick={handleGetEmailParams}
                  id="log-in-email"
                  className="email__login"
                  href={`/login/?landing_id=${landingId}`}
                >
                  Log in
                </a>
                <p className="email_login-text"> or use another email.</p>
              </div>
            )}
          </div>
        </div>
        <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
      </div>
    </>
  );
};
export default Email;
